import React, { useState } from 'react';
import Modal from '../ui/Modal';
import TrashIcon from '../icons/TrashIcon';
import { Project } from '../../types/project';
import './DeleteModal.css';

interface DeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  itemName: string;
  itemType?: string;
  isDeleting?: boolean;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  itemName,
  itemType = 'project',
  isDeleting = false
}) => {
  const handleDeleteConfirm = () => {
    onConfirm();
  };

  const handleClose = () => {
    onClose();
  };

  // Show only the confirmation dialog
  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      maxWidth="500px"
      showCloseButton={true}
      title=' '
    >
      <div className="delete-modal-content second-step">
        <div className="delete-modal-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120" fill="none">
            <path d="M60.8486 5.01367C64.5055 5.14817 68.0603 6.28411 71.123 8.30371C74.186 10.3234 76.6303 13.1437 78.1943 16.4521L78.4951 17.1201L78.4961 17.1221L80.7988 22.5H110C112.761 22.5 115 24.7386 115 27.5C115 30.2614 112.761 32.5 110 32.5H105.885L100.511 103.442C100.273 106.586 98.8565 109.523 96.5449 111.666C94.2333 113.809 91.1972 114.999 88.0449 114.999V115H31.9551V114.999C28.8028 114.999 25.7667 113.809 23.4551 111.666C21.1436 109.523 19.7269 106.586 19.4893 103.442L14.1152 32.5H10C7.23858 32.5 5 30.2614 5 27.5C5 24.7386 7.23858 22.5 10 22.5H39.2012L41.5039 17.1221L41.5049 17.1201C43.0476 13.5213 45.6123 10.4543 48.8818 8.2998C52.1506 6.1459 55.98 4.99944 59.8945 5.00098V5H60.1152L60.8486 5.01367ZM29.4609 102.688V102.688C29.5085 103.317 29.7917 103.904 30.2539 104.333C30.7163 104.762 31.3236 105 31.9541 105H88.0459C88.6764 105 89.2837 104.762 89.7461 104.333C90.2083 103.904 90.4915 103.317 90.5391 102.688V102.688L95.8574 32.5H24.1426L29.4609 102.688ZM50 42.5C52.7614 42.5 55 44.7386 55 47.5V90C55 92.7614 52.7614 95 50 95C47.2386 95 45 92.7614 45 90V47.5C45 44.7386 47.2386 42.5 50 42.5ZM70 42.5C72.7614 42.5 75 44.7386 75 47.5V90C75 92.7614 72.7614 95 70 95C67.2386 95 65 92.7614 65 90V47.5C65 44.7386 67.2386 42.5 70 42.5ZM59.8926 15C57.9349 14.9989 56.0195 15.5723 54.3848 16.6494C52.7508 17.7261 51.4668 19.2584 50.6953 21.0566L50.6963 21.0576L50.0791 22.5H69.9209L69.3037 21.0576V21.0566C68.5326 19.2595 67.2508 17.7279 65.6182 16.6514C63.9847 15.5743 62.0709 15.0002 60.1143 15H59.8926Z" fill="url(#paint0_linear_136_888)" />
            <defs>
              <linearGradient id="paint0_linear_136_888" x1="5" y1="60" x2="115" y2="60" gradientUnits="userSpaceOnUse">
                <stop stopColor="#D94B4B" />
                <stop offset="1" stopColor="#ED7A24" />
              </linearGradient>
            </defs>
          </svg>
        </div>

        <h2 className="delete-modal-title">Delete {itemType}?</h2>

        <p className="delete-modal-description">
          Deleting "{itemName}" will permanently remove all unsaved or unexported data.
        </p>

        <div className="delete-modal-actions second-step-actions">
          <button
            className="delete-modal-go-back"
            onClick={handleClose}
            disabled={isDeleting}
          >
            Cancel
          </button>
          <button
            className="delete-modal-delete"
            onClick={handleDeleteConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteModal;